import { render } from "./TitleAiCrateView.vue?vue&type=template&id=d61f35b4&scoped=true"
import script from "./TitleAiCrateView.vue?vue&type=script&lang=js"
export * from "./TitleAiCrateView.vue?vue&type=script&lang=js"

import "./TitleAiCrateView.vue?vue&type=style&index=0&id=d61f35b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61f35b4"]])

export default __exports__